import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en } from './en';
import { sv } from './sv';

// The UI language (OQ-162, ui/app-views.md § Language): Swedish by default,
// the device's last choice before sign-in, the user's own choice after it.
export type Language = 'sv' | 'en';
export const LANGUAGE_STORAGE_KEY = 'language';

export const isLanguage = (value: unknown): value is Language => value === 'sv' || value === 'en';

export const initialLanguage = (): Language => {
  try {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isLanguage(stored) ? stored : 'sv';
  } catch {
    return 'sv';
  }
};

const setHtmlLang = (language: Language) => {
  document.documentElement.lang = language;
};

/** Switches the UI and remembers the choice on the device. */
export const applyLanguage = async (language: Language) => {
  await i18n.changeLanguage(language);
  setHtmlLang(language);
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // The device just does not remember it.
  }
};

const startLanguage = initialLanguage();

void i18n.use(initReactI18next).init({
  resources: { sv: { translation: sv }, en: { translation: en } },
  lng: startLanguage,
  fallbackLng: 'sv',
  interpolation: { escapeValue: false },
  initAsync: false
});
setHtmlLang(startLanguage);

export default i18n;
